/* @flow */

export default class SetFinancialInfoRequest {
  debtorCompanyId: number;
  leadId: number;

  numberOfSuppliers: number;
  yearlyInvoiceAmount: number;
  turnOver: string;
}